// Packages
import PropTypes from 'prop-types'

// Components
import NoteForm from 'modules/Notes/components/Form';

// Other
import useApi from 'hooks/useApi';

const NoteCreateScreen = ({ onClose, onSubmit, parent, parentId }) => {

    const { post: createItem, errors } = useApi('/notes',  false)

	const submit = async (values) => {

        if( await createItem({[parent]: parentId, ...values}, 'Note created!') ) {
    
            onSubmit();
        }
    }


    return(
        <NoteForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

NoteCreateScreen.propTypes = {
	onClose: PropTypes.func,
	onSubmit: PropTypes.func,
    parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

NoteCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')},
    parent: '',
    parentId: ''
}

export default NoteCreateScreen;